import { OnInit, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-invalid-link-for-external',
  templateUrl: './invalid-link-for-external.component.html',
  styleUrls: ['./invalid-link-for-external.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InvalidLinkForExternalComponent implements OnInit {
  isOldJwtLink: string | null = null;
  invalidLinkDescription: string;

  @Input()
  invalidLinkHeader = 'invalidLinkHeader';


  @Input()
  externalKey?: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.isOldJwtLink = this.route.snapshot.queryParamMap.get('jwt');
    this.invalidLinkDescription = `${this.invalidLinkHeader}Description`;
  }

  buildTranslationKey(relativeKey: string): string {
    if (this.externalKey) {
      return `${this.externalKey}.${relativeKey}`;
    }
    return `externalApproval.${relativeKey}`;
  }
}
